import { useState, useContext } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";

function CorrectStudent11() {
  const {
    setClass11Candidateid,
    setClass11Mode,
    setClass11Divyangcode,
    setClass11Castecode,
    setClass11JacStudent,
    setClass11OtherMode,
    setClass11otherstudent,
    setClass11exregularmode,
    setClass11exregulartudent,
    setClass11before2010mode,
    setClass11before2010,
  } = useContext(ContextBoard);
  const navigate = useNavigate();

  const [candidateId, setCandidateId] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSearch = async () => {
    if (!candidateId) {
      Swal.fire("Warning", "Please enter Candidate ID", "warning");
      return;
    }

    if (candidateId.length > 20) {
      Swal.fire("Warning", "Candidate ID cannot exceed 20 digits", "warning");
      return;
    }

    setLoading(true);
    const token = sessionStorage.getItem("tokenclassxi");

    try {
      setLoading(true);
      const preCheckResponse = await fetch(
        `${config.API_BASE_URL}/SchoolForCorrectionPortal_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            candidatE_ID: candidateId,
          }),
        }
      );

      const preCheckData = await preCheckResponse.json();

      // ❌ If validation API does NOT return 200
      if (!preCheckResponse.ok) {
        Swal.fire(
          "error",
          preCheckData?.message || "Candidate validation failed",
          "error"
        );
        return;
      }

      const response = await fetch(
        `${config.API_BASE_URL}/GetStudentByCandidateId_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            candidatE_ID: candidateId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched Candidate Data:", data);

      const student = data?.data?.editStudent_data;

      if (!student) {
        Swal.fire("Error", "No student data found", "error");
        return;
      }

      setClass11Candidateid(student.candidatE_ID);
      setClass11Castecode(student.cast);
      setClass11Divyangcode(student.divyang);

      if (student.ediT_REDIRECTION === "JAC_Registration") {
        setClass11JacStudent(student);
        navigate("/class-xi-correction-regular");
      } else if (student.ediT_REDIRECTION === "Others_Registration") {
        setClass11otherstudent(student);
        navigate("/class-xi-correction-others");
      } else if (student.ediT_REDIRECTION === "EX_Registration") {
        setClass11exregulartudent(student);
        setClass11exregularmode("edit");
        navigate("/class-xi-correction-exregular");
      } else {
        setClass11before2010(student);
        navigate("/class-xi-correction-board-registration");
      }
    } catch (error) {
      console.error("Failed to fetch candidate data:", error);
      Swal.fire(
        "Error",
        "Something went wrong. Please try again later.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      <div className="container-scroller">
        <Navbar11 />

        <div className="container-fluid page-body-wrapper">
          <Sidebar11 />

          <div className="main-panel">
            <div className="content-wrapper">
              <h4 className="mb-3">
                <i className="fa fa-user"></i>&nbsp;Correct Student Data
              </h4>

              <div className="card">
                <div className="card-body">
                  <div className="row align-items-end">
                    <div className="col-md-3">
                      <label className="mb-2">Please Enter Candidate ID:</label>
                      <input
                        type="text"
                        value={candidateId}
                        maxLength={20}
                        onChange={(e) => setCandidateId(e.target.value)}
                        className="form-control form-control-xs"
                        placeholder="Candidate ID"
                      />
                    </div>

                    <div className="col-md-2">
                      <button
                        className="btn btn-success mt-4"
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search"></i>&nbsp;Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectStudent11;
